module.exports = __webpack_public_path__ + "img/info8-bg.542d18be.svg";